export default "<div class=\"button-container\">\n  <p>subscribe now</p>\n</div>\n"